import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { ExplanationText } from '~/App/views/ObjectPage/components/ExplanationText';
import { Collapse } from 'react-collapse';
import { formatMoneyWithoutCurrency } from '~/helpers/currency';
import { useTranslation } from '~/Locale';
import { BodyText, generateNameHash } from '@kvdbil/components';
import { Info } from './IconButtons/Info';

const PriceWrapper = styled(BodyText)<{ gray?: boolean }>`
  flex-direction: row;
  width: 100%;
  display: flex;
  justify-content: space-between;
  ${({ gray, theme }) =>
    gray ? `color: ${theme.colors.grayscaleToned.dark3};` : ''}
  column-gap: 1rem;
`;

const PriceLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
const PriceValue = styled.span`
  display: flex;
  white-space: nowrap;
  align-items: center;
`;

interface Props {
  title: string;
  price: number;
  currency?: string;
  explanation: React.ReactNode;
  gray?: boolean;
}

const TooltipPrice = ({ title, price, currency, explanation, gray }: Props) => {
  const { t } = useTranslation();
  const [isExplanationVisible, setExplanationVisible] = useState(false);
  const idRef = useRef(generateNameHash('price-info-content'));
  return (
    <div>
      <PriceWrapper as="div" gray={gray}>
        <PriceLabel>
          {title}
          <Info
            isInfoOpened={isExplanationVisible}
            onClick={() => setExplanationVisible(prev => !prev)}
            ariaControls={idRef.current}
          />
        </PriceLabel>
        <PriceValue>
          {formatMoneyWithoutCurrency(price)} {currency ? currency : t('SEK')}
        </PriceValue>
      </PriceWrapper>
      <Collapse isOpened={isExplanationVisible}>
        <ExplanationText id={idRef.current}>{explanation}</ExplanationText>
      </Collapse>
    </div>
  );
};

export default TooltipPrice;
